/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DC` - Deal Cancelled
 * `ML` - Missed Loading
 * `NC` - No Coverage
 * `NI` - No Inspector
 * `NN` - Not Needed
 * `OT` - Other
 * `SR` - Site Refused
 */
export type CancellationReasonEnum = (typeof CancellationReasonEnum)[keyof typeof CancellationReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationReasonEnum = {
  DC: 'DC',
  ML: 'ML',
  NC: 'NC',
  NI: 'NI',
  NN: 'NN',
  OT: 'OT',
  SR: 'SR',
} as const;
